import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './i18n/LanguageContext';
import Header from './components/Header/Header';
import SearchBar from './components/SearchBar/SearchBar';
import Welcome from './components/Welcome/Welcome';
import LatestArticles from './components/LatestArticles/LatestArticles';
import About from './components/About/About';
import AboutDetail from './components/About/AboutDetail';
import Footer from './components/Footer/Footer';
import Articles from './components/Articles/Articles';
import Contact from './components/Contact/Contact';
import Authors from './components/Authors/Authors';
import AdvancedSearch from './components/Search/AdvancedSearch';
import Map from './components/Map/Map';
import ArticleDetail from './components/Articles/ArticleDetail';
import SearchResults from './components/SearchResults/SearchResults';
import SorumlulukReddi from './components/SorumlulukReddi/sorumlulukReddi';
import GizlilikPolitikasi from './components/GizlilikPolitikasi/gizlilikPolitikasi';
import AuthorDetail from './components/Authors/AuthorDetail';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

// Wrapper component to handle SearchBar visibility
const SearchBarWrapper = () => {
  const location = useLocation();
  const hideSearchBar = location.pathname === '/gelismisArama' || 
                       location.pathname === '/aramaSonuclari' ||
                       location.pathname === '/harita' || 
                       location.pathname === '/sorumluluk-reddi' || 
                       location.pathname === '/gizlilik-politikasi' || 
                       location.pathname === '/hakkinda' || 
                       location.pathname === '/yazar' ||
                       location.pathname.startsWith('/yazar/');
  
  return !hideSearchBar ? <SearchBar /> : null;
};

function App() {
  return (
    <Router>
      <LanguageProvider>
        <ScrollToTop />
        <div className="app">
          <Header />
          <SearchBarWrapper />
          <main className="app-main">
          <Routes>
          <Route path="/" element={
            <>
              <Welcome />
              <LatestArticles />
            </>
          } />
          <Route path="/hakkinda" element={<About />} />
          <Route path="/hakkinda/detay" element={<AboutDetail />} />
          <Route path="/maddeler" element={<Articles />} />
          <Route path="/maddeler/kategori/:catId" element={<Articles />} />
          <Route path="/maddeler/detay/:title" element={<ArticleDetail />} />
          <Route path="/yazarlar" element={<Authors />} />
          <Route path="/iletisim" element={<Contact />} />
          <Route path="/gelismisArama" element={<AdvancedSearch />} />
          <Route path="/harita" element={<Map />} />
          <Route path="/article/:id/:slug?" element={<ArticleDetail />} />
          <Route path="/detay/:id/:slug?" element={<ArticleDetail />} />
          <Route path="/aramaSonuclari" element={<SearchResults />} />
          <Route path="/sorumluluk-reddi" element={<SorumlulukReddi />} />
          <Route path="/gizlilik-politikasi" element={<GizlilikPolitikasi />} />
          <Route path="/yazar/:id" element={<AuthorDetail />} />
        </Routes>
          </main>
        <Footer />
        </div>
      </LanguageProvider>
    </Router>
  );
}

export default App;
